module.exports = __webpack_public_path__ + "static/img/design.74a92b8e.png";